// extracted by mini-css-extract-plugin
module.exports = {"defaulIcon":"infoitem_defaulIcon__3q5Ea","valueCol":"infoitem_valueCol__3tGhT"};